import type { Prototype } from "../prototype-types";

export const jasonHuPrototypes: Prototype[] = [
  {
    id: "jh-test-mobile-homepage",
    name: "Test mobile homepage",
    path: "/jh/test-mobile-homepage",
    description: "Mobile retailer homepage with product tiles",
    owner: "Jason Hu",
    createdAt: "2026-06-19",
    lastUpdated: "2026-06-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "https://cdn.faire.com/fastly/9fdb1ae739c9714fd21fefa6db67692f69d187c6a0295c4e774d3684b2f0f103.png",
    creationTool: "claude-code",
  },
  {
    id: "jh-messaging-banner-non-nav-ctas",
    name: "Messaging Banner non-navigation CTAs",
    path: "/jh/messaging-banner-non-nav-ctas",
    description: "What the CTA actually does for the 5 web Messaging Banner cases whose action is not navigation",
    owner: "Jason Hu",
    createdAt: "2026-09-17",
    lastUpdated: "2026-09-17",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jh-messaging-banner-non-nav-ctas.png",
    creationTool: "cursor",
  }
];
